import { render, staticRenderFns } from "./fccFilas.vue?vue&type=template&id=629f0095"
import script from "./fccFilas.vue?vue&type=script&lang=js"
export * from "./fccFilas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports